import Component from '@glimmer/component';

export default class AppProfileWatch extends Component {}
